export default "__VITE_ASSET__58033a5d__"